import { render } from "./Storage Sections.vue?vue&type=template&id=96ba2350"
import script from "./Storage Sections.vue?vue&type=script&lang=js"
export * from "./Storage Sections.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__